module.exports = __webpack_public_path__ + "img/background_stuffs_overlay.732cd0c5.png";